import { FormControl } from "./FormControl";

export const SwitchSize = {
    SMALL: '',
    LARGE: 'switch-lg'
};

export const LabelPosition = {
    LEFT: 'switch-rtl',
    RIGHT: ''
}

/** @deprecated Use Fundamentals/Switch/Switch instead. */
export function SwitchToggle({
    label,
    checked,
    onChange,
    disabled,
    id,
    size = SwitchSize.LARGE,
    labelPosition = LabelPosition.LEFT
}) {
    return (
        <FormControl>
            <label className={`switch ${size} ${labelPosition}`}>
                <input
                    type="checkbox"
                    id={id ?? label}
                    disabled={disabled}
                    checked={checked ?? false}
                    defaultValue={checked}
                    onChange={(e) => onChange(e.target.checked, e.target.id)}
                   
                />
                <span htmlFor={id ?? label} className="togglemark">{label}</span>
            </label>
        </FormControl>
    );
}